export default __webpack_public_path__ + "static/media/artwork.2ace13c9.png";